var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 90 92"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    d: "M0 35.912c0-.438.201-.85.546-1.12L44.123.686a1.42 1.42 0 0 1 1.754 0L89.454 34.79c.345.27.546.684.546 1.121v54.664c0 .787-.637 1.424-1.424 1.424H1.423A1.423 1.423 0 0 1 0 90.576z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#house_svg__a)",
    fillOpacity: 0.21,
    d: "M0 35.912c0-.438.201-.85.546-1.12L44.123.686a1.42 1.42 0 0 1 1.754 0L89.454 34.79c.345.27.546.684.546 1.121v54.664c0 .787-.637 1.424-1.424 1.424H1.423A1.423 1.423 0 0 1 0 90.576z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#house_svg__b)",
    d: "M0 35.912c0-.438.201-.85.546-1.12L44.123.686a1.42 1.42 0 0 1 1.754 0L89.454 34.79c.345.27.546.684.546 1.121v54.664c0 .787-.637 1.424-1.424 1.424H1.423A1.423 1.423 0 0 1 0 90.576z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#house_svg__c)",
    d: "M0 35.912c0-.438.201-.85.546-1.12L44.123.686a1.42 1.42 0 0 1 1.754 0L89.454 34.79c.345.27.546.684.546 1.121v54.664c0 .787-.637 1.424-1.424 1.424H1.423A1.423 1.423 0 0 1 0 90.576z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#house_svg__d)",
    fillOpacity: 0.63,
    d: "M0 35.912c0-.438.201-.85.546-1.12L44.123.686a1.42 1.42 0 0 1 1.754 0L89.454 34.79c.345.27.546.684.546 1.121v54.664c0 .787-.637 1.424-1.424 1.424H1.423A1.423 1.423 0 0 1 0 90.576z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.33,
    d: "M0 35.912c0-.438.201-.85.546-1.12L44.123.686a1.42 1.42 0 0 1 1.754 0L89.454 34.79c.345.27.546.684.546 1.121v54.664c0 .787-.637 1.424-1.424 1.424H1.423A1.423 1.423 0 0 1 0 90.576z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    d: "M43.89 68.313v-13.89H30V52.13h13.89V38.312h2.291v13.82H60v2.29H46.181v13.89h-2.29Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "house_svg__a",
    x1: 66.727,
    x2: -18.558,
    y1: -134.534,
    y2: -131.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#895FFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house_svg__b",
    x1: -86.434,
    x2: 298.468,
    y1: 46,
    y2: 45.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895FFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#9E7AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house_svg__c",
    x1: 9.315,
    x2: 87.113,
    y1: 92,
    y2: 92.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#3682FA",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house_svg__d",
    x1: -21.38,
    x2: 150.236,
    y1: 45.837,
    y2: 45.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgHouse;